import { Layout } from "antd";
import RecruitmentBody from "../../components/recruitment/RecruitmentBody";

const UserManagement = () => {
  return (
    <>
      <Layout style={{ minHeight: "100vh", padding: "20px" }} className="max-w-6xl w-full mx-auto">
        <RecruitmentBody />
      </Layout>
    </>
  );
};

export default UserManagement;
